<template>
  <div :class="[playNowClass, 'landscape-ranking']">
    <a
      href="javascript:void(0)"
      role="button"
      @click.prevent="$emit('on-click')"
    >
      <div class="thumb-image">
        <div
          class="no-thumb"
          :aria-hidden="!isImageLoaded"
          :style="`display: ${displayCss}`"
        >
          <span class="alt-text">{{ alt }}</span>
        </div>
        <ul class="badge-list">
          <li class="left-top-area">
            <ul v-top-tag-list="topTagList" />
          </li>
        </ul>
        <div class="picture-area">
          <WebpImage
            :image-info="{
              imageUrl: cellInfo.thumbnail,
              width: thumbnailInfo.width,
              height: thumbnailInfo.height,
              onImageLoad,
              alt: altTitle,
              className: 'thumb-img',
            }"
          />
        </div>
        <div v-if="hasProgress" class="cell-progress">
          <span
            class="gradation-purple"
            :style="'width:' + Number(progress) * 100 + '%;'"
          ></span>
        </div>
        <age-limits :target-age="targetAge" :age-tag="ageTag" />
        <div :class="adultDimClass"></div>
      </div>
      <div class="cell-info-wrapper">
        <div v-if="rankValue" class="rank-image-wrapper">
          <img :src="rankingImgUrl" :alt="rankingImgAlt" />
        </div>
        <div class="sub-title">
          <div
            ref="title"
            v-title-list="{
              titleList: cellInfo.title_list,
              cellType: 'landscape',
              callback: loaded,
            }"
            class="sub-right"
          />
        </div>
      </div>
    </a>
  </div>
</template>

<script>
  import _ from 'lodash'
  import AgeLimits from '@/components/model/AgeLimits'
  import shave from 'shave'
  import {
    titleList,
    topTagList,
    commonTagList,
  } from '@/common/resources/directives'
  import CellMixIn from '@/mixins/cell.mixin'
  import fp from 'lodash/fp'
  import { getCellEventObject } from '@/common/utils/gnb.fp'
  import WebpImage from '@/components/image/WebpImage'
  export default {
    directives: {
      titleList,
      topTagList,
      commonTagList,
    },
    components: {
      WebpImage,
      AgeLimits,
    },
    mixins: [CellMixIn],
    props: {
      cellInfo: {
        type: Object,
      },
      thumbnailInfo: {
        type: Object,
      },
    },
    computed: {
      playNowClass() {
        const nowChannelId = _.get(this.$route, ['query', 'channelid'], '')
        const { onNavigation } = fp.flow(
          fp.get('event_list'),
          getCellEventObject,
        )(this.cellInfo)
        const url = _.get(onNavigation, 'url', '')
        const contentId = url.split('=').pop()
        const isPlayNowCta = onNavigation.cta === 'icon_autoplay'
        return (nowChannelId !== '' && nowChannelId === contentId) ||
          isPlayNowCta
          ? 'thumb landscape playnow'
          : 'thumb landscape'
      },
      rankValue() {
        return this.cellInfo?.rank
      },
      checkValidRank() {
        const candidate = Array.from({ length: 20 }, (_, i) => `${i + 1}`)
        return candidate.findIndex((el) => el === this.rankValue) !== -1
      },
      rankingImgUrl() {
        return this.checkValidRank
          ? require(
              `@/assets/images/main/landscape-rank/landscape-rank-${this.rankValue}@3x.png`,
            )
          : ''
      },
      rankingImgAlt() {
        return this.checkValidRank ? `랭킹 ${this.rankValue}위` : ''
      },
    },
    methods: {
      loaded(el) {
        this.$nextTick(() => {
          _.forEach(el.querySelectorAll('.line1'), (line1El) => {
            shave(line1El, 28)
          })
        })
      },
    },
  }
</script>

<style lang="scss" src="@/assets/scss/import/landscape.scss"></style>
<style lang="css">
  .list-view-detail .live-ui .landscape {
    float: none;
    display: inline-block;
    vertical-align: top;
  }
</style>
<!--.landscape class 사용함. playNowClass() 참고-->
<style lang="scss" scoped>
  .multi .swiper-slide span.creator-name {
    margin: -2px 0 0;
  }
  .landscape {
    float: none;
    display: inline-block;
    margin-right: 0;
    vertical-align: top;
    &.landscape-ranking {
      width: 407px;
      .thumb-image {
        min-width: 407px;
        min-height: 229px;
      }
      .cell-info-wrapper {
        display: flex;
        padding-top: 8px;
        align-items: center;
        .rank-image-wrapper {
          height: 60px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 8px;
          img {
            width: auto;
            height: 100%;
          }
        }
        .sub-title {
          padding-top: 0;
        }
      }
    }
    > a {
      height: 100%;
    }
    .thumb-image {
      width: 100%;
      height: 100%;
    }
  }
</style>
